import { CLIENTS_PERMISSIONS } from "./clients";

export const SUPER_ADMIN_ROLE = "admin";
export const ORG_ADMIN_ROLE = "org_admin";
export const ORG_ADVISOR_ROLE = "org_advisor";
export const ORG_CLIENT_ROLE = "org_client";
export const USER_ROLES = [SUPER_ADMIN_ROLE, ORG_ADMIN_ROLE, ORG_ADVISOR_ROLE, ORG_CLIENT_ROLE];

export const CLIENT_PERMISSIONS_TO_ROLES = {
  [CLIENTS_PERMISSIONS.MANAGE]: [SUPER_ADMIN_ROLE, ORG_ADMIN_ROLE, ORG_ADVISOR_ROLE],
  [CLIENTS_PERMISSIONS.CLEAR_CREDENTIALS]: [SUPER_ADMIN_ROLE],
  [CLIENTS_PERMISSIONS.RISK_DETAILS]: [SUPER_ADMIN_ROLE, ORG_ADMIN_ROLE],
};
